import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { AgeSelect } from '../../../../components/inputs/AgeSelect';
import { SingleSelect } from '../../../../components/inputs/SingleSelect';
import { GIFT_AMOUNTS } from '../../../../config/dropdowns';
import type { GeoLevel } from '../../types';

import { mapControlsStyles as styles } from './MapControls.styles';

const GEO_LEVEL_OPTIONS = [
  { id: 'state', label: 'State' },
  { id: 'county', label: 'County' },
] as const;

interface MapControlsProps {
  geoLevel: GeoLevel;
  onGeoLevel: (level: GeoLevel) => void;
  ageIds: string[];
  onAge: (ids: string[]) => void;
  amountId: string;
  onAmount: (id: string) => void;
  /**
   * `toggle` (default) is the desktop segmented State/County control.
   * `select` condenses it to a single dropdown, matching the mobile Figma
   * frames where the three controls (level/age/amount) are uniform pills.
   */
  geoLevelVariant?: 'toggle' | 'select';
}

export function MapControls({
  geoLevel,
  onGeoLevel,
  ageIds,
  onAge,
  amountId,
  onAmount,
  geoLevelVariant = 'toggle',
}: MapControlsProps) {
  return (
    <Box sx={styles.root}>
      {geoLevelVariant === 'select' ? (
        <SingleSelect
          value={geoLevel}
          onChange={(next) => onGeoLevel(next as GeoLevel)}
          options={GEO_LEVEL_OPTIONS}
          variant="standard"
          ariaLabel="Geographic level"
          sx={styles.select}
        />
      ) : (
        <ToggleButtonGroup
          exclusive
          value={geoLevel}
          onChange={(_, next: GeoLevel | null) => next && onGeoLevel(next)}
          sx={styles.toggleGroup}
          aria-label="Geographic level"
        >
          <ToggleButton value="state" sx={styles.toggle}>
            State
          </ToggleButton>
          <ToggleButton value="county" sx={styles.toggle}>
            County
          </ToggleButton>
        </ToggleButtonGroup>
      )}

      <AgeSelect value={ageIds} onChange={onAge} sx={styles.select} ariaLabel="Age ranges" />

      <SingleSelect
        value={amountId}
        onChange={onAmount}
        options={GIFT_AMOUNTS}
        variant="standard"
        ariaLabel="Gift amount"
        sx={styles.select}
      />
    </Box>
  );
}
